
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    dataType: {
      type: String,
      default: "other",
    },
    showTooltip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconClass() {
      switch (this.dataType) {
        case "date":
          return "icon-type-datetime";
        case "string":
          return "icon-type-text";
        case "boolean":
          return "icon-type-boolean";
        case "integer":
          return "icon-type-integer";
        case "float":
          return "icon-type-float";
        case "binary":
          return "icon-type-binary";
        case "multiclass":
          return "icon-type-list";
        case "regression":
          return "icon-type-regression";
        default:
          return "icon-type-other";
      }
    },
    tooltip(): string {
      return this.showTooltip ? `datasource.datatype.${this.dataType}` : "";
    },
  },
});
